import React from "react"

type Props = {
  src: string
  alt: string
  width?: string
  height?: string
  style?: React.CSSProperties
}

const ImageComponent: React.FC<Props> = ({
  src,
  alt,
  width = "90px",
  height,
  style,
}) => {
  const imageContainerStyle: React.CSSProperties = {
    width,
    height,
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    ...style,
  }

  const imageStyle: React.CSSProperties = {
    width: "100%",
    height: "124px",
    objectFit: "cover",
  }

  return (
    <div style={imageContainerStyle}>
      <img src={src} alt={alt} style={imageStyle} />
    </div>
  )
}

export default ImageComponent
